/*
 * @Author: 前端 qianduan01@didihu.com.cn
 * @Date: 2024-03-11 18:04:47
 * @LastEditors: 前端 qianduan01@didihu.com.cn
 * @LastEditTime: 2024-03-12 10:58:35
 * @FilePath: \dj-car-life-system\src\router\modules\907_home.js
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */
const _import = require("@/libs/util.import." + process.env.NODE_ENV)
export const routerName = {
  907: {
    path: "/index",
    name: "index",
    meta: {
      title: "总览",
      authId: "907",
      parentId: "1",
      icon: "s-home",
      cache: false,
      sideHidden: false
    },
    auth: [
      {
        authId: "90701",
        parentId: "907",
        label: "报表模块"
      },
      {
        authId: "90702",
        parentId: "907",
        category: "Button",
        label: "查看企微推送对象",
        addRoutePath: [
          {
            authId: "90703",
            name: "企微推送配置",
            parentId: "907"
          }
        ]
      },
      // {
      //   authId: "90705",
      //   parentId: "907",
      //   category: "Button",
      //   label: "编辑单店信息"
      // },
      {
        authId: "90706",
        parentId: "907",
        category: "Button",
        type: "primary",
        label: "导出日报",
        handle: "exportDailyReport"
      },
      {
        authId: "90707",
        parentId: "907",
        category: "Button",
        label: "渗透率报表",
        addRoutePath: [
          {
            authId: "90704",
            name: "渗透率报表",
            parentId: "907"
          }
        ]
      },
      {
        authId: "90708",
        parentId: "907",
        category: "Button",
        handle: "handleOutputImport",
        label: "导入"
      }
    ],
    component: _import("index")
  },
  90703: {
    path: "/outputValue",
    name: "outputValue",
    meta: {
      title: "企微推送对象",
      authId: "90703",
      parentId: "907",
      cache: false,
      sideHidden: true,
      activePath: "/index"
    },
    auth: [
      {
        authId: "9070301",
        parentId: "90703",
        label: "新增",
        icon: "plus",
        category: "Button",
        type: "primary",
        handle: "handleAdd"
      },
      {
        authId: "9070303",
        parentId: "90703",
        label: "导入",
        category: "Button",
        handle: "handleImport"
      },
      {
        authId: "9070302",
        parentId: "90703",
        label: "编辑",
        handle: "handleEdit"
      },
      {
        authId: "9070304",
        parentId: "90703",
        label: "删除",
        handle: "handleDelete"
      }
    ],
    component: _import("index/outputValue")
  },
  90704: {
    path: "/permeation",
    name: "permeation",
    meta: {
      title: "渗透率报表",
      authId: "90704",
      parentId: "907",
      cache: false,
      sideHidden: true,
      activePath: "/index"
    },
    auth: [
      {
        authId: "9070401",
        parentId: "90704",
        label: "导出",
        category: "Button",
        type: "primary",
        handle: "handleExport"
      },
      // 新车交付率导出
      {
        authId: "9070402",
        parentId: "90704",
        label: "导出",
        category: "Button",
        type: "primary",
        handle: "handleDetailExport"
      },
      {
        authId: "9070403",
        parentId: "90704",
        label: "日报导出",
        category: "Button",
        type: "primary",
        handle: "handleDailyExport"
      }
    ],
    component: _import("index/permeation")
  }
}
